import React, { useState } from "react";
import "./HomeContent.css";
import { NavLink, Link } from "react-router-dom";
import Carousel from "nuka-carousel";
import TestimonialData from "../../data/HomeTestimonials.json";
import HomeWallOfFame from "../../data/HomeWallOfFame.json";
import NukaCarousel from "nuka-carousel";
import FloatIcon from "../FloatIcons/FloatIcons";
import { Grid, Typography, Box, Stack } from "@mui/material";
import OfferingsData from '../../data/Offerings.json';
import Testimonial from "./Testimonials";

function HomeContent({ value, setValue, languageValue, setLanguageValue }) {
  const [hovered, setHovered] = useState(-1);

  const handleFlip = (i) => {
    setHovered(i);
  };

  return (
    <>
      {/* Float Icon Start */}
      <div className="floatIconsContainer">
        <FloatIcon />
      </div>
      {/* Float Icon End */}

      {/*Old Banner carousel Start */}
      {/* <div className="bannerCarouselContainer">
        <Carousel
          autoplay
          wrapAround
          id="homeBannerCarouse"
          className="homeBannerCarouse"
          renderCenterLeftControls={({ previousSlide }) => (
            <button className="bannerCarouseArrowLeft" onClick={previousSlide}>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/homePage/bannerLeftArrow.png"
                }
                alt="Banner"
                className="bannerCarouseArrowLeftIcon"
              />
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button className="bannerCarouseArrowRight" onClick={nextSlide}>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/homePage/bannerRightArrow.png"
                }
                alt="Banner"
                className="bannerCarouseArrowRightIcon"
              />
            </button>
          )}
        >
          <div className="bannerCarouselCard">
            <img
              src={process.env.PUBLIC_URL + "/images/homePage/Banner-1.png"}
              alt="Banner"
              className="bannerCarouselCardBgImg"
            />
            <div className="bannerCarouselCardText">
              <h1 id="bannerCarouselCardTextH1One">Expand Your Horizons</h1>
              <h1 id="bannerCarouselCardTextH1Two">
                Learn a Foreign Language Today!
              </h1>
            </div>
          </div>
          <div className="bannerCarouselCard">
            <img
              src={process.env.PUBLIC_URL + "/images/homePage/11k.png"}
              alt="Banner"
              className="bannerCarouselCardBgImg"
            />
          </div>
          <div className="bannerCarouselCard">
            <img
              src={process.env.PUBLIC_URL + "/images/homePage/1900.png"}
              alt="Banner"
              className="bannerCarouselCardBgImg"
            />
          </div>
          <div className="bannerCarouselCard">
            <img
              src={process.env.PUBLIC_URL + "/images/homePage/Banner-2.png"}
              alt="Banner"
              className="bannerCarouselCardBgImg"
            />
          </div>
        </Carousel>
      </div> */}
      {/*Old Banner End */}

      {/* Banner sec  */}
      <div className="home-banner">
        <img
          src={process.env.PUBLIC_URL + "/images/homePage/Banner.png"}
          alt="banner"
          className="banner-img"
        />
        <div className="banner-text">
          <h1>Expand your Horizons</h1>
          <h2>Learn a Foreign Language Today!</h2>
          <p>Embark on a journey of personal and professional growth with our
            Foregin Language Learning program. Unlock new opportunities by
            immersing yourself in the language of your choice. Our experienced
            and certified trainers will guide you through interactive sessions
            and activities, ensuring a fun and effective learning experience.
            Gain fluency and proficiency, validated by internal and external
            certifications. Don't hesitate; seize the chance to learn French,
            German, Spanish, Italian or Japanese today. Enroll now and open
            doors to a world of possibilities</p>
        </div>
        <Link to="/events">
          <div className="bannerIcons icon1" onClick={()=>setValue(1)}>
            <img src="/images/homePage/bannerIcon1.png" alt="spanish-icon" className="banner-icons-img" />
            <span className="banner-icon-text">Spanish</span>
          </div>
          <div className="bannerIcons icon2" onClick={()=>setValue(0)}>
            <img src="/images/homePage/bannerIcon2.png" alt="french-icon" className="banner-icons-img" />
            <span className="banner-icon-text">French</span>
          </div>
          <div className="bannerIcons icon3" onClick={()=>setValue(3)}>
            <img src="/images/homePage/bannerIcon3.png" alt="german-icon" className="banner-icons-img" />
            <span className="banner-icon-text">German</span>
          </div>
          <div className="bannerIcons icon4" onClick={()=>setValue(2)}>
            <img src="/images/homePage/bannerIcon4.png" alt="italian-icon" className="banner-icons-img" />
            <span className="banner-icon-text">Italian</span>
          </div>
          <div className="bannerIcons icon5" onClick={()=>setValue(4)}>
            <img src="/images/homePage/bannerIcon5.png" alt="japanese-icon" className="banner-icons-img" />
            <span className="banner-icon-text">Japanese</span>
          </div>
        </Link>

        <div className="stats-container">
          <div className="stats-wrap">
            <div className="stats-row">
              <div className="stats-box">
                <img src={process.env.PUBLIC_URL + "/images/homePage/icon1.png"} alt="statistics-icon" className="stats-icon" />
                <p className="stats-count">11K+</p>
                <p>Participants enrolled</p>
              </div>
              <div className="vertical-line"></div>
              <div className="stats-box">
                <img src={process.env.PUBLIC_URL + "/images/homePage/icon2.png"} alt="statistics-icon" className="stats-icon" />
                <p className="stats-count">3000+</p>
                <p>Training completed</p>
              </div>
              <div className="vertical-line"></div>
              <div className="stats-box">
                <img src={process.env.PUBLIC_URL + "/images/homePage/icon3.png"} alt="statistics-icon" className="stats-icon" />
                <p className="stats-count">2300+</p>
                <p>Internally certified</p>
              </div>
              <div className="vertical-line"></div>
              <div className="stats-box">
                <img src={process.env.PUBLIC_URL + "/images/homePage/icon3.png"} alt="statistics-icon" className="stats-icon" />
                <p className="stats-count">300+</p>
                <p>Externally certified</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Overview Start */}
      {/* <div className="overviewSection">
        <div className="overTextGridContainer">
          <div className="overTextGridContent">
            <h2 className="overTextGridContentH2">Overview</h2>
            <p className="overTextGridContentP">
              Embark on a journey of personal and professional growth with our
              Foregin Language Learning program. Unlock new opportunities by
              immersing yourself in the language of your choice. Our experienced
              and certified trainers will guide you through interactive sessions
              and activities, ensuring a fun and effective learning experience.
              Gain fluency and proficiency, validated by internal and external
              certifications. Don't hesitate; seize the chance to learn French,
              German, Spanish, Italian or Japanese today. Enroll now and open
              doors to a world of possibilities
            </p>
          </div>
          <div className="overTextGridContentRight">
            <img
              src={process.env.PUBLIC_URL + "/images/homePage/overview.png"}
              alt="OverView"
              className="overTextGridContentOverImg"
            />
          </div>
        </div>
      </div> */}
      {/* Overview End */}

      {/* Exploring Section Start */}
      {/* <div className="exploringSectionContainer">
        <div className="exploringSectionTextContent">
          <h2 className="exploringSectionTextH3">LKM Foreign Language Offerings</h2>
          <div className="exploringSectionTextContentGridContainer">
            <div className="exploringSectionTextContentGridContent">
              <img
                src={process.env.PUBLIC_URL + "/images/homePage/French.png"}
                alt="French"
                className="explotingFirstTopicImg"
              />
              <h4 className="explotingFirstTopicHeading">French</h4>
              <p className="explotingFirstTopicText">
                Bonjour! Learn French with Ease and Confidence
              </p>

              <Link
                className="explotingFirstTopicLink"
                to={{
                  pathname: "/learnings",
                  state: { selectedLang: "French" },
                }}
              >
                Learn More
              </Link>
            </div>
            <div className="exploringSectionTextContentGridContent">
              <img
                src={process.env.PUBLIC_URL + "/images/homePage/Spanish.png"}
                alt="Spanish"
                className="explotingFirstTopicImg"
              />
              <h4 className="explotingFirstTopicHeading">Spanish</h4>
              <p className="explotingFirstTopicText">
                Hola! Learn Spanish and open Doors to a world of Opportunities
              </p>
              <Link
                className="explotingFirstTopicLink"
                to={{
                  pathname: "/learnings",
                  state: { selectedLang: "Spanish" },
                }}
              >
                Learn More
              </Link>
            </div>
            <div className="exploringSectionTextContentGridContent">
              <img
                src={process.env.PUBLIC_URL + "/images/homePage/ITALIAN.png"}
                alt="Italian"
                className="explotingFirstTopicImg"
              />
              <h4 className="explotingFirstTopicHeading">Italian</h4>
              <p className="explotingFirstTopicText">
                Ciao! Learn Italian and Immerse Yourself in La Dolce Vita
              </p>
              <Link
                className="explotingFirstTopicLink"
                to={{
                  pathname: "/learnings",
                  state: { selectedLang: "Italian" },
                }}
              >
                Learn More
              </Link>
            </div>
            <div className="exploringSectionTextContentGridContent">
              <img
                src={process.env.PUBLIC_URL + "/images/homePage/german.png"}
                alt="Italian"
                className="explotingFirstTopicImg"
              />
              <h4 className="explotingFirstTopicHeading">German</h4>
              <p className="explotingFirstTopicText">
                Guten Tag! Learn German and Discover a World of Possibilities
              </p>
              <Link
                className="explotingFirstTopicLink"
                to={{
                  pathname: "/learnings",
                  state: { selectedLang: "German" },
                }}
              >
                Learn More
              </Link>
            </div>
            <div className="exploringSectionTextContentGridContent">
              <img
                src={process.env.PUBLIC_URL + "/images/homePage/Japanese.png"}
                alt="Italian"
                className="explotingFirstTopicImg"
              />
              <h4 className="explotingFirstTopicHeading">Japanese</h4>
              <p className="explotingFirstTopicText">
                Konnichiwa! Learn Japanese, bridge cultures and explore
                limitless opportunities
              </p>
              <Link
                className="explotingFirstTopicLink"
                to={{
                  pathname: "/japaneseLearning",
                }}
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div> */}
      {/* Exploring Section End */}

      {/* Offerings sec  */}
      <div className="offerings-wrap">
        <h2 className="offerings-heading">L&TT Foreign Language Offerings</h2>
        <div className="border-gradient horizontal-underline only-top"></div>
        <div className="offerings-card-outer">
          {
            OfferingsData.map((item, i) => {
              return (
                <div className="offerings-container">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={process.env.PUBLIC_URL + item.langIcon} alt="lang-icon" className="langIcon" />
                        <h4>{item.langName}</h4>
                        <p>{item.langIntro}</p>
                        <img src={process.env.PUBLIC_URL + "/images/homePage/card-underline.png"} alt="underline" className="card-underline" />
                      </div>
                    </div>
                    <div className="flip-card-back flip-card-content">
                      <div className="back-content">
                        <img src={process.env.PUBLIC_URL + item.langIcon} className="back-icon" alt="lang-icon" />
                        <p>{item.langDesc}</p>
                        <Link
                          className="learn-more"
                          to={item.learnMoreLink}
                          // target="_blank"
                          onClick={()=>{setLanguageValue(item.langName)
                            console.log(item.langName, "onclick lang name")
                          }}
                        >
                          Learn More
                        </Link>
                        <img src={process.env.PUBLIC_URL + "/images/homePage/card-underline2.png"} alt="underline" className="card-underline" />
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>

      {/* Testimonials new section  */}
      <div className="testimonials__main_container">
        <div className="testimonials__container">
          {/* <h2 className="key__characteristics__title">Testimonials</h2> */}

          <Testimonial />
        </div>
      </div>

      {/* Wall of Fame Start */}
      {/* <div className="wallOfFameContainer">
        <div className="wallOfFameTextContainer">
          <h2 className="wallFOfFameHeading">LKM Foreign Language Wall of Fame</h2>
          <div className="wallOfFameCarouselContainer">
            <Carousel
              slidesToScroll={5}
              slidesToShow={5}
              id="wallOfFameCarouse"
              className="wallofFameCarousel"
              renderCenterLeftControls={({ previousSlide }) => (
                <button
                  className="bannerCarouseArrowLeft"
                  onClick={previousSlide}
                >
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/homePage/Group 188496.png"
                    }
                    alt="Banner"
                    className="wallOfFameCarouseArrowLeftIcon"
                  />
                </button>
              )}
              renderCenterRightControls={({ nextSlide }) => (
                <button className="bannerCarouseArrowRight" onClick={nextSlide}>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/homePage/Group 188495.png"
                    }
                    alt="Banner"
                    className="wallOfFameCarouseArrowRightIcon"
                  />
                </button>
              )}
            >
              {HomeWallOfFame.map((item) => {
                return (
                  <div
                    className="wallGridContent"
                    style={{ borderColor: item.borderColor }}
                  >
                    <div className="wallGridContentProfileImgContainer">
                      <img
                        src={item.backgroundImgPath}
                        alt="Bg"
                        className="wallGridContentTopImg"
                      />
                      <div className="languageTextContainer">
                        <p className="wallGridContentLanguage">
                          {item.language} {item.languageLevel}
                        </p>
                      </div>
                    </div>

                    <div className="wallGridContentTextContainer">
                      <h4 className="wallGridContentName">{item.name}</h4>
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </div> */}
      {/* Wall of Fame End */}

      {/* Testimonials Start */}
      {/* <section className="testimonialContainer">
        <div className="testimonialContentSection">
          <h2 className="testimonialHeading">Testimonials</h2>
          <Carousel
            id="homeBannerCarouse"
            className="homeBannerCarouse"
            renderCenterLeftControls={({ previousSlide }) => (
              <button
                className="testimonialsCarouseArrowLeft"
                onClick={previousSlide}
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/homePage/bannerLeftArrow.png"
                  }
                  alt="Banner"
                  className="testimonialsCarouseArrowLeftImg"
                />
              </button>
            )}
            renderCenterRightControls={({ nextSlide }) => (
              <button
                className="testimonialsCarouseArrowRight"
                onClick={nextSlide}
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/homePage/bannerRightArrow.png"
                  }
                  alt="Banner"
                  className="testimonialsCarouseArrowRightImg"
                />
              </button>
            )}
          >
            {TestimonialData.map((item) => {
              return (
                <div className="testimonialCards">
                  <div className="testimonialTextContainer">
                    <img
                      src="/images/homePage/testimonial BG A.png"
                      alt="Bg"
                      className="testimonialTextBg"
                    />
                    <div className="testimonialText">
                      <p className="testimonialP">{item.testimony}</p>
                    </div>
                  </div>
                  <div className="testimonialProfileContainer">
                    <p className="testimonialProfileName">{item.name}</p>
                    <p className="testimonialProfileBand">{item.band}</p>
                  </div>
                </div>
              );
            })}
          </Carousel>
        </div>
      </section> */}
      {/* Testimonials End */}
    </>
  );
}

export default HomeContent;
